/** 查重 UI：文件名 / 后缀展示 */

const EXT_RE = /\.([a-z0-9]{1,8})$/i

export function dedupFileExt(name?: string | null): string {
  if (!name) return ''
  const m = name.trim().match(EXT_RE)
  return m ? m[1].toUpperCase() : ''
}

/** 带点后缀，如 .pdf、.docx */
export function dedupFileSuffix(name?: string | null): string {
  const ext = dedupFileExt(name)
  return ext ? `.${ext.toLowerCase()}` : ''
}

/** 展示用完整文档名：标题 + 附件后缀（普通文本，不拆分高亮） */
export function dedupDocLabel(title: string, originalName?: string | null): string {
  const base = (title || '—').trim()
  const file = (originalName || '').trim()
  const suffix = dedupFileSuffix(file || base)
  if (!suffix) {
    return base
  }
  if (base.toLowerCase().endsWith(suffix.toLowerCase())) {
    return base
  }
  return `${base}${suffix}`
}

/** 新窗口打开重复片段对照页 */
export function openDedupMatchWindow(reportId: number, itemId: number) {
  const url = `/dedup/matches/${reportId}/${itemId}`
  window.open(url, '_blank', 'noopener,noreferrer')
}
